import React, { Component } from 'react';
import { LoginDrawer as Drawer } from 'components/Styled';
import LoginOrRegister from 'components/auth/LoginOrRegister';

class LoginDrawer extends Component {
  render() {
    return (
      <Drawer
        placement="left"
        onClose={this.props.onClose}
        visible={this.props.visible}
        closable={true}
        width={'100%'}>
        <LoginOrRegister
          email={this.props.email}
          page={this.props.page}
          onPageChange={this.props.onPageChange}
        />
      </Drawer>
    );
  }
}

export default LoginDrawer;
